const redactFromUrl = (url: string) => {
  return url.replace(/at=[^&]*/, 'at=REDACTED');
};

export { redactFromUrl };
